'use client';

import { websiteEnv } from '@/constants/website-env';
import Link from 'next/link';
import classes from './errorView.module.css';

const ErrorView = props => {
  const { message } = props;

  return (
    <div
      className={classes.root}
      data-cy='ErrorView-root'
    >
      <div className={classes.content}>
        <img
          className={classes.img}
          src={`${process.env.NEXT_PUBLIC_BASE_PATH}/media/wysiwyg/404.png`}
          alt=''
        />
        <p className={classes.header}>Ohhh!Page Not Found</p>
        <p className={classes.message}>It seems we can&apos;t find what you&apos;re looking for.</p>
        <p className={classes.message}>Error Info: {message}</p>
        <p className={classes.goBack}>
          Go back to our <Link href='/'>AW Bridal Home Page.</Link>
        </p>
        <div className={classes.list}>
          <p className={classes.listTitle}>Explore AW Bridal Brand...</p>

          <ul className={classes.listContainer}>
            <li className={classes.listItem}>
              <div>
                <Link
                  href={`/wedding-dresses`}
                  className='flex flex-col items-center'
                >
                  <img
                    src={`${process.env.NEXT_PUBLIC_BASE_PATH}/media/wysiwyg/pagenotfound1.jpg`}
                    alt='Wedding Dresses'
                  />
                  <span>Wedding Dresses</span>
                </Link>
              </div>
            </li>
            <li className={classes.listItem}>
              <div>
                <Link
                  href={`/bridesmaid-dresses`}
                  className='flex flex-col items-center'
                >
                  <img
                    src={`${process.env.NEXT_PUBLIC_BASE_PATH}/media/wysiwyg/pagenotfound2.jpg`}
                    alt='Bridesmaid Dresses'
                  />
                  <span>Bridesmaid Dresses</span>
                </Link>
              </div>
            </li>
            <li className={classes.listItem}>
              <div>
                <Link
                  href={`/mother-of-the-bride-dresses`}
                  className='flex flex-col items-center'
                >
                  <img
                    src={`${process.env.NEXT_PUBLIC_BASE_PATH}/media/wysiwyg/pagenotfound3.jpg`}
                    alt='Mother of the Bride Dresses'
                  />
                  <span>Mother of the Brides</span>
                </Link>
              </div>
            </li>
            {websiteEnv.isUnitedStates ? (
              <li className={classes.listItem}>
                <div>
                  <Link
                    href={`/wedding-accessories`}
                    className='flex flex-col items-center'
                  >
                    <img
                      src={`${process.env.NEXT_PUBLIC_BASE_PATH}/media/wysiwyg/pagenotfound4.jpg`}
                      alt='Wedding Accessories'
                    />
                    <span>Accessories</span>
                  </Link>
                </div>
              </li>
            ) : null}
            <li className={classes.listItem}>
              <div>
                <Link
                  href={`/${websiteEnv.isUnitedStates ? 'ready-to-ship' : 'wedding-guest-dresses'}`}
                  className='flex flex-col items-center'
                >
                  <img
                    src={`${process.env.NEXT_PUBLIC_BASE_PATH}/media/wysiwyg/pagenotfound6.jpg`}
                    alt={websiteEnv.isUnitedStates ? 'Ready to Ship' : 'Wedding Guest Dresses'}
                  />
                  <span>{websiteEnv.isUnitedStates ? 'Ready to Ship' : 'Wedding Guest Dresses'}</span>
                </Link>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ErrorView;
